
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const DemoCallPage = lazy(() => import('../pages/demo-call/page'));
const PaymentPage = lazy(() => import('../pages/payment/page'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/[slug]/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const RefundPolicyPage = lazy(() => import('../pages/refund-policy/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const AccessibilityStatementPage = lazy(() => import('../pages/accessibility-statement/page'));
const DataRequestPage = lazy(() => import('../pages/data-request/page'));
const LostRevenueCalculatorPage = lazy(() => import('../pages/lost-revenue-calculator/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />,
  },
  {
    path: '/demo-call',
    element: <DemoCallPage />,
  },
  {
    path: '/lost-revenue-calculator',
    element: <LostRevenueCalculatorPage />,
  },
  {
    path: '/payment',
    element: <PaymentPage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '/refund-policy',
    element: <RefundPolicyPage />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicyPage />,
  },
  {
    path: '/accessibility-statement',
    element: <AccessibilityStatementPage />,
  },
  {
    path: '/data-request',
    element: <DataRequestPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
